import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link, withRouter } from 'react-router';
import ShowCategories from '../components/categories/ShowCategories';
import { clearAuthErrors, fetchCategories, disableCategory, clearCategoriesErrors } from '../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  categories: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class CategoriesPage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  // TODO: review this, why duplication on each Container - gabo
  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    this.props.dispatch(clearCategoriesErrors());
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.categories.search && this.props.categories.search.length > 0) {
      query.search = this.props.categories.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/categories', query });
    } else {
      this.props.dispatch(fetchCategories(query));
    }
  }
  onCategoryDisable(data) {
    this.props.dispatch(disableCategory(data));
  }
  handleSearchChange(e) {
    const categories = this.props.categories;
    const query = this.props.query;
    const router = this.props.router;
    const nextCategory = e.target.value;
    categories.search = nextCategory;
    this.setState({
      categories,
    });
    if (nextCategory.length > 0) {
      query.search = nextCategory;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/categories', query });
    this.props.dispatch(fetchCategories(query));
  }
  navigation(route) {
    // add search to url
    this.props.dispatch(fetchCategories(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="categories component" style={authPage}>
        <h2>Categories</h2>
        <div className="content">
          <div className="action-buttons">
            <Link to="/categories/new">
              <RaisedButton
                label="Add New Category"
                primary
              />
            </Link>
          </div>
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.categories.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.categories.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowCategories
            categories={this.props.categories}
            onCategoriesDisable={data => this.onCategoriesDisable(data)}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.categories.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

CategoriesPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CategoriesPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    categories: state.categories,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(CategoriesPage));



// WEBPACK FOOTER //
// ./src/containers/CategoriesPage.js